
export class BroadcastSummaryModel {
    broadcastName: string;
    id: number;
    totalMessages: number;
    sent: number;
    failed: number;
    progress: number;
    scheduledTime: string;

    /**
     * 
     * @param broadcastName 
     * @param id 
     * @param totalMessages 
     * @param sent 
     * @param failed 
     * @param progress 
     * @param scheduledTime
     */
    constructor( broadcastName: string, id: number, totalMessages: number, sent: number, failed: number, progress: number, scheduledTime: string) {
        this.broadcastName = broadcastName;
        this.id = id;
        this.totalMessages = totalMessages;
        this.sent = sent;
        this.failed = failed;
        this.progress = progress;
        this.scheduledTime = scheduledTime;
    }
}